import gql from 'graphql-tag'

export const GET_ADDRESS = gql`
  query Geofences($filter: GetGeofencesFilter) {
    geofences(filter: $filter) {
      isSuccessful
      message
      geofences {
        data {
          geofenceId
          companyId
          customerId
          fenceName
          type
          polyData
          circData
          address
          addressDetail
          province
          city
          postalCode
          category
          contactName
          phoneNo
          isGarage
          isServiceLoc
          isBillingAddr
          isDepot
          isAlert
          serviceStart
          serviceEnd
          breakStart
          breakEnd
          serviceLocType
          customerName
          hasRelation
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const CREATE_ADDRESS = gql`
  mutation CreateGeofence($input: CreateGeofenceInput!) {
    createGeofence(input: $input) {
      isSuccessful
      message
      geofence {
        geofenceId
      }
    }
  }
`

export const UPDATE_ADDRESS = gql`
  mutation UpdateGeofence($input: UpdateGeofenceInput!) {
    updateGeofence(input: $input) {
      isSuccessful
      message
      geofence {
        geofenceId
      }
    }
  }
`

export const GET_CITIES = gql`
  query CitiesByCountry {
    citiesByCountry {
      isSuccessful
      message
      citiesByCountry {
        country
        province
        city
      }
    }
  }
`

export const GET_DETAIL_ADDRESS = gql`
  query Geofence($filter: GetGeofenceInput!) {
    geofence(filter: $filter) {
      isSuccessful
      message
      geofence {
        geofenceId
        companyId
        customerId
        fenceName
        type
        polyData
        circData
        address
        addressDetail
        province
        city
        postalCode
        category
        contactName
        phoneNo
        isGarage
        isServiceLoc
        isBillingAddr
        isDepot
        serviceStart
        serviceEnd
        breakStart
        breakEnd
        serviceLocType
        hasRelation
      }
    }
  }
`

export const DELETE_ADDRESS = gql`
  mutation DeleteGeofence($input: DeleteGeofenceInput!) {
    deleteGeofence(input: $input) {
      isSuccessful
      message
    }
  }
`

export const GET_ADDRESS_UPLOAD_HISTORY = gql`
  query ImportHistory($filter: ImportHistoriesFilter) {
    importHistory(filter: $filter) {
      isSuccessful
      message
      importHistory {
        filename
        importOn
        model
        totalFailed
        totalSuccess
        users {
          fullname
        }
      }
    }
  }
`
export const IMPORT_GEOFENCES = gql`
  mutation ImportGeofences($input: ImportGeofenceInput!) {
    importGeofences(input: $input) {
      importGeofences {
        errorFile
        totalData
        totalFailed
        totalSuccess
      }
      isSuccessful
      message
    }
  }
`
